import { render, staticRenderFns } from "./delta-view.vue?vue&type=template&id=ab94d474&"
import script from "./delta-view.vue?vue&type=script&lang=js&"
export * from "./delta-view.vue?vue&type=script&lang=js&"
import style0 from "./delta-view.vue?vue&type=style&index=0&id=ab94d474&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports